var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Inject, Watch, Emit } from 'vue-property-decorator';
import FormSelect from "@/components/forms/FormSelect.vue";
var MembershipSelect = /** @class */ (function (_super) {
    __extends(MembershipSelect, _super);
    function MembershipSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = 0;
        return _this;
    }
    Object.defineProperty(MembershipSelect.prototype, "groups", {
        get: function () {
            var _a, _b, _c, _d;
            this.model = Number((_b = (_a = this.session.user) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.slice(0, 1).map(function (i) { return i.id; }));
            if (parseInt(this.$route.params.groupId)) {
                this.model = parseInt(this.$route.params.groupId);
            }
            return (_d = (_c = this.session.user) === null || _c === void 0 ? void 0 : _c.groups) === null || _d === void 0 ? void 0 : _d.map(function (group) {
                return {
                    text: group.name,
                    value: group.id,
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    MembershipSelect.prototype.onGroupChange = function (group) {
        this.group = group;
        return group.value;
    };
    MembershipSelect.prototype.onUserUpdate = function () {
        var _a;
        var group = (_a = this.groups) === null || _a === void 0 ? void 0 : _a[0];
        if (group) {
            this.group = group;
        }
    };
    __decorate([
        Inject(),
        __metadata("design:type", Object)
    ], MembershipSelect.prototype, "session", void 0);
    __decorate([
        Emit('membershipChanged'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], MembershipSelect.prototype, "onGroupChange", null);
    __decorate([
        Watch('session.user'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MembershipSelect.prototype, "onUserUpdate", null);
    MembershipSelect = __decorate([
        Component({
            components: {
                FormSelect: FormSelect,
            },
        })
    ], MembershipSelect);
    return MembershipSelect;
}(Vue));
export default MembershipSelect;
